module.exports = __webpack_public_path__ + "static/media/fachesf.79f94793.webp";